import { initNav } from './nav.js';
import { initScrollImages } from './scroll-images.js';
import { initFaq } from './faq.js';
import { initArbeitSection } from './arbeit-section.js';
import { initWebstoryArea } from './intro-section.js';
import { initChecklistSection } from './checklist-section.js';
import { initContactSection } from './contact-section.js';
import { initDBPSection } from './dbp-section.js';
import { initAblaufSection } from './ablauf-section.js';
import { initCollabSection } from './collab-section.js';
import { initSectionLinesBackground } from './section-lines-bg.js';
import { initVisToolsSlider } from './vis-tools-slider.js';

function lazyInitSection(selector, loader, label) {
  if (!document.querySelector(selector)) return;
  loader().catch((error) => console.warn(`[${label}] init skipped`, error));
}


export function initAllSections() {
  initSectionLinesBackground();
  initNav();
  initScrollImages();
  initFaq();
  initArbeitSection();
  initWebstoryArea();
  initChecklistSection();
  initContactSection();
  initDBPSection();
  initAblaufSection();
  initCollabSection();
  initVisToolsSlider();
  lazyInitSection(
    "#section-webd-stk, .section-webd-stk, .webd-stk-pin-group",
    () => import('./webd-stk-section.js').then(({ initWebdStkSection }) => initWebdStkSection()),
    "WebdStk"
  );
  lazyInitSection(
    "#section-colorcina, .section-colorcina, .colorcina-pin-group",
    () => import('./colorcina-section.js').then(({ initColorcinaSection }) => initColorcinaSection()),
    "Colorcina"
  );
  lazyInitSection(
    "#section-vis-stackflow, .section-vis-stackflow, .vis-stackflow-stage",
    () => import('./vis-stackflow-section.js').then(({ initVisStackflowSection }) => initVisStackflowSection()),
    "VisStackflow"
  );
  lazyInitSection(
    ".section-subsidect, #section-subsidect, #section-subsidect-brand",
    () => import('./subsidect-section.js').then(({ initSubsidect }) => initSubsidect()),
    "Subsidect"
  );
}
